"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeRow = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__TimeRow",
  componentId: "sc-1tay1su-0"
})(["text-align:center;"]);

var TimeBoxContainer = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__TimeBoxContainer",
  componentId: "sc-1tay1su-1"
})(["display:flex;justify-content:center;margin-bottom:16px;"]);

var TimeUnit = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__TimeUnit",
  componentId: "sc-1tay1su-2"
})(["margin-right:3px;margin-left:3px;:first-child{margin-left:0;}:last-child{margin-right:0;}"]);

var TimeBox = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__TimeBox",
  componentId: "sc-1tay1su-3"
})(["min-width:70px;height:56px;padding:0 15px;border:1px solid ", ";background:", ";text-shadow:0 0 2px rgba(0,0,0,0.8);font-size:36px;font-weight:800;text-align:center;color:", ";@media (max-width:767px){height:49px;width:56px;min-width:auto;padding:0 6px;font-size:32px;}"], function (props) {
  return props.styles.boxBorder;
}, function (props) {
  return props.styles.boxColor;
}, function (props) {
  return props.styles.timeColor;
});

var Unit = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__Unit",
  componentId: "sc-1tay1su-4"
})(["font-size:12px;font-weight:bold;text-align:center;color:", ";"], function (props) {
  return props.styles.unitColor;
});

var Colon = _styledComponents["default"].div.withConfig({
  displayName: "CountDownClock__Colon",
  componentId: "sc-1tay1su-5"
})(["::after{content:\":\";font-size:24px;font-weight:bold;line-height:56px;text-align:center;color:", ";}"], function (props) {
  return props.styles.colonColor;
});

var CountDownClock = function CountDownClock(_ref) {
  var deadline = _ref.deadline,
      styles = _ref.styles;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    boxColor: Theme["mlb-blue"],
    boxBorder: Theme["almost-black"],
    timeColor: Theme["white"],
    unitColor: Theme["mlb-blue"],
    colonColor: Theme["mlb-blue"]
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  var _React$useState = _react["default"].useState(new Date().getTime()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      now = _React$useState2[0],
      setNow = _React$useState2[1];

  (0, _react.useEffect)(function () {
    var timerID = setInterval(function () {
      return tick();
    }, 1000);
    return function cleanup() {
      clearInterval(timerID);
    };
  });

  function tick() {
    setNow(new Date().getTime());
  }

  var time = deadline - now < 0 ? 0 : deadline - now;
  var days = Math.floor(time / (1000 * 60 * 60 * 24));
  var hours = Math.floor(time % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  var minutes = Math.floor(time % (1000 * 60 * 60) / (1000 * 60));
  var seconds = Math.floor(time % (1000 * 60) / 1000);
  return _react["default"].createElement("div", null, _react["default"].createElement(TimeRow, {
    style: {
      display: "block"
    }
  }, _react["default"].createElement("div", {
    style: {
      display: "inline-block"
    }
  }, _react["default"].createElement(TimeBoxContainer, null, _react["default"].createElement(TimeUnit, {
    style: {
      display: "block"
    }
  }, _react["default"].createElement(TimeBox, {
    styles: CompStyles
  }, days), _react["default"].createElement(Unit, {
    styles: CompStyles
  }, "Days")), _react["default"].createElement(Colon, {
    style: {
      display: "block"
    },
    styles: CompStyles
  }), _react["default"].createElement(TimeUnit, null, _react["default"].createElement(TimeBox, {
    styles: CompStyles
  }, hours), _react["default"].createElement(Unit, {
    styles: CompStyles
  }, "Hours")), _react["default"].createElement(Colon, {
    styles: CompStyles
  }), _react["default"].createElement(TimeUnit, null, _react["default"].createElement(TimeBox, {
    styles: CompStyles
  }, minutes), _react["default"].createElement(Unit, {
    styles: CompStyles
  }, "Minutes")), _react["default"].createElement(Colon, {
    styles: CompStyles
  }), _react["default"].createElement(TimeUnit, null, _react["default"].createElement(TimeBox, {
    styles: CompStyles
  }, seconds), _react["default"].createElement(Unit, {
    styles: CompStyles
  }, "Seconds"))))));
};

CountDownClock.defaultProps = {
  styles: {}
};
CountDownClock.propTypes = {
  /** overrideable styles */
  styles: _propTypes["default"].shape({
    boxColor: _propTypes["default"].string,
    boxBorder: _propTypes["default"].string,
    timeColor: _propTypes["default"].string,
    unitColor: _propTypes["default"].string,
    colonColor: _propTypes["default"].string
  }),

  /** when the countdown clock ends */
  deadline: _propTypes["default"].instanceOf(Date).isRequired
};
var _default = CountDownClock;
exports["default"] = _default;